import SubCardTitle from "../../../../components/styled/SubCardTitle";
import { arrayMap, chunkArray } from "../../../../utils/array.utils";

export default function VehicleShowroomWorkList({ data }) {
  const chunkData = chunkArray(data, 10);
  let serialNumber = 1;
  return (
    <div className="card border-0" style={{ height: `100%` }}>
      <div className="card-body">
        <SubCardTitle>Work List</SubCardTitle>
        <div className="row g-3">
          {arrayMap(chunkData, (item, i) => {
            return (
              <div key={i} className="col-12 col-md-6">
                <ul className="list-unstyled mb-0">
                  {arrayMap(item, (innerItem, j) => {
                    return (
                      <li key={j}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div style={{ width: `60%` }}>
                            {serialNumber++}. {innerItem?.name?.label ?? ""}
                            {innerItem?.remarks ? ` (${innerItem.remarks})` : ""}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
